import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00f6f03c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 1,
  class: "tir-pm-file-preview__file tir-pm-file-preview__file--document"
}
const _hoisted_3 = { class: "tir-pm-file-preview__preview-extension" }
const _hoisted_4 = {
  key: 2,
  class: "tir-pm-file-preview__file tir-pm-file-preview__file--video"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "tir-pm-file-preview__video-button"
}
const _hoisted_7 = {
  key: 0,
  class: "tir-pm-file-preview__wrapper-info"
}
const _hoisted_8 = { class: "tir-pm-file-preview__wrapper-info-row" }
const _hoisted_9 = {
  key: 0,
  class: "tir-pm-file-preview__user-info-round"
}
const _hoisted_10 = { class: "tir-pm-file-preview__inner-file-info" }
const _hoisted_11 = { class: "tir-pm-file-preview__wrapper-filename" }
const _hoisted_12 = { class: "tir-pm-file-preview__file-extension" }
const _hoisted_13 = {
  key: 0,
  class: "tir-pm-file-preview__wrapper-file-info"
}
const _hoisted_14 = { class: "tir-pm-file-preview__file-upload-time" }
const _hoisted_15 = {
  key: 0,
  class: "tir-pm-file-preview__file-size"
}
const _hoisted_16 = {
  key: 1,
  class: "tir-pm-file-preview__small-progress"
}
const _hoisted_17 = {
  key: 2,
  class: "tir-pm-file-preview__list-controls"
}
const _hoisted_18 = { class: "tir-pm-file-preview__inline-name" }
const _hoisted_19 = { class: "tir-pm-file-preview__inline-file-ext" }
const _hoisted_20 = {
  key: 1,
  class: "tir-pm-file-preview__inline-buttons"
}
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]

import { computed, PropType, ref } from "vue";
import {
  TirPmIconView,
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
} from "tir-components";
import {
  DocumentIcon,
  CrossCompactIcon,
  PencilSquareIcon,
  ArrowDownTrayIcon,
  PlayCircleIcon,
} from "tir-style-system/icons/outline";
import { IFilePreview } from "./interfaces";
import {
  formatFileSize,
  getDateUploadString,
  getFileExtension,
  downloadFile,
} from "./utils";
import { imageExtensions, videoExtensitons } from "./constants";
import {
  FilePreviewConfirmDeletePopover,
  FilePreviewEditNamePopover,
  FilePreviewModal,
  FilePreviewProgress,
} from "./components";
import {
  FileTypeEnum,
  FilePreviewAccessEnum,
  FilePreviewVariantEnum,
} from "./enums";


export default /*#__PURE__*/_defineComponent({
  __name: 'tir-pm-file-preview',
  props: {
  /**Информация о файле */
  file: {
    type: Object as PropType<T>,
    required: true,
  },
  /**Весь список файлов */
  files: {
    type: Array as PropType<Array<T>>,
    default: [],
  },
  /**Вариант компонента */
  variant: {
    type: String as PropType<FilePreviewVariantEnum>,
    default: () => FilePreviewVariantEnum.Regular,
  },
  /**Вариант для файлов кроме медиа */
  noMediaVariant: {
    type: String as PropType<FilePreviewVariantEnum>,
    default: () => FilePreviewVariantEnum.Regular,
  },
  /**Загрузка при удалении */
  isLoadingDelete: {
    type: Boolean,
    default: false,
  },
  /**Загрузка при редактировании названия */
  filesLoadingEditName: {
    type: Array as PropType<Array<T["FileId"]>>,
    default: [],
  },
  /**Отключить открытие модального окна */
  isDisabledOpen: {
    type: Boolean,
    default: false,
  },
  /**Скрыть контролы */
  hideControls: {
    type: Boolean,
    default: false,
  },
  /**Состояние выбранного файла */
  isSelected: {
    type: Boolean,
    default: false,
  },
  /**Пропустить подтверждение при удалении */
  skipRemoveConfirm: {
    type: Boolean,
    default: false,
  },
},
  emits: ["onClickDelete", "onClickEdit", "saveName"],
  setup(__props, { emit }) {

const props = __props;



const emitSaveName = (fileId: T["FileId"], filename: string) => {
  emit("saveName", fileId, filename);
};


/**Режим полного экрана для модалки */
const previewFullscreenModal = ref(false);
/**Информация о файле */
const fileInfo = computed(() => props.file as IFilePreview);
/**Состояние загрузки файла */
const isLoading = computed(
  () => fileInfo.value.Progress !== undefined && !fileInfo.value.IsProccessing
);
/**Имя пользователя который загрузил фото для аватарки */
const computedFotoName = computed(() => {
  if (!fileInfo.value.User) return;
  const { FirstName, LastName } = fileInfo.value.User;

  return `${FirstName?.[0]?.toLocaleUpperCase()}${LastName?.[0]?.toLocaleUpperCase()}`;
});
/**Расщирение файла */
const fileExtension = computed(() => {
  return getFileExtension(fileInfo.value.Name);
});
/**Название файла (без расширения) */
const fileName = computed(() => {
  const lastDotIndex = fileInfo.value.Name.lastIndexOf(".");
  if (lastDotIndex === -1) return fileInfo.value.Name; // Если точки нет, возвращаем исходное имя
  return fileInfo.value.Name.substring(0, lastDotIndex);
});
/**Тип файла */
const fileType = computed(() => {
  switch (true) {
    case imageExtensions.includes(fileExtension.value):
      return FileTypeEnum.Image;
    case videoExtensitons.includes(fileExtension.value):
      return FileTypeEnum.Video;
    default:
      return FileTypeEnum.Other;
  }
});
/**Разрешено удаление/отмена */
const isAccessDelete = computed(() =>
  fileInfo.value.Accesses?.includes(FilePreviewAccessEnum.Remove)
);
/**Ссылка на поповер подтверждения удаления */
const $confirmDeletePopover =
  ref<InstanceType<typeof FilePreviewConfirmDeletePopover>>();
/**Открыт ли поповер с подтверждением удаления */
const isOpenedConfirmDeletePopover = ref(false);
/**Отправить событие клика на кнопку удаления */
const emitOnClickDelete = () => {
  if (props.isLoadingDelete) return;
  emit("onClickDelete");
};
/**При клике на кнопку удаления */
const onClickDelete = () => {
  if (fileInfo.value.IsProccessing || !isAccessDelete.value) return;
  if (fileInfo.value.Progress !== undefined || props.skipRemoveConfirm) {
    emitOnClickDelete();
  } else {
    $editNamePopover.value?.close();
    $confirmDeletePopover.value?.open();
  }
};
/**Разрешено редактирование */
const isAccessEdit = computed(
  () =>
    fileInfo.value.Accesses?.includes(FilePreviewAccessEnum.Edit) &&
    !isLoading.value
);
/**Ссылка на поповер редактирования названия файла */
const $editNamePopover = ref<InstanceType<typeof FilePreviewEditNamePopover>>();
/**Открыт ли поповер редактирования названия */
const isOpenedEditNamePopover = ref(false);
/**При клике на кнопку редактирования */
const onClickEdit = () => {
  // Если изображение
  if (
    imageExtensions.includes(fileExtension.value) &&
    !["gif", "svg"].includes(fileExtension.value)
  ) {
    emit("onClickEdit", fileInfo.value.FileId);
  } else {
    $confirmDeletePopover.value?.close();
    $editNamePopover.value?.open();
  }
};
/**Разрешено ли скачивать */
const isAccessDownload = computed(
  () =>
    !fileInfo.value.IsProccessing &&
    !isLoading.value &&
    fileType.value !== FileTypeEnum.Video
);
/**Видимость контролов */
const isViewControls = computed(
  () =>
    !props.hideControls &&
    !fileInfo.value.IsProccessing &&
    (isAccessDelete.value || isAccessEdit.value)
);
/**Отображаемый вариант файла */
const viewVariant = computed(() => {
  if (fileType.value === FileTypeEnum.Other) return props.noMediaVariant;
  return props.variant;
});
/**Дата загрузки в виде строки */
const dateUploadString = computed(
  () =>
    fileInfo.value.DateUpload && getDateUploadString(fileInfo.value.DateUpload)
);
/**Размер файла в виде строки */
const sizeString = computed(
  () => fileInfo.value.Size && formatFileSize(fileInfo.value.Size)
);

/**Загрузка файла */
const download = () => {
  downloadFile(fileInfo.value.Url, `${fileInfo.value.Name}`);
};

/**Превью файла */
const previewFile = ref<IFilePreview>();
/**Открыть модальное окно с превью файла */
const openFilePreviewModal = () => {
  if (
    props.isDisabledOpen ||
    fileInfo.value.Progress !== undefined ||
    fileInfo.value.IsProccessing
  )
    return;
  if (fileType.value === FileTypeEnum.Other) {
    download();
    return;
  }

  previewFile.value = fileInfo.value;
};
/**Закрытие модального окна предпросмотра */
const closeFilePreviewModal = () => {
  previewFile.value = undefined;
};
/**Список медиафайлов */
const filesForModal = computed(() => {
  const mediaFiles = props.files.filter((file) => {
    const ext = getFileExtension(file.Name);
    return imageExtensions.includes(ext) || videoExtensitons.includes(ext);
  });

  return mediaFiles.filter(
    (file) => file.Progress === undefined && !file.IsProccessing
  );
});
/**Индекс превью файла в списке медиафайлов */
const currentPreviewFileIndex = computed(() => {
  if (!filesForModal.value.length || !previewFile.value) return -1;
  return filesForModal.value.findIndex(
    (file) => file.FileId === previewFile.value.FileId
  );
});

const previewNextFile = () => {
  if (currentPreviewFileIndex.value === filesForModal.value.length - 1) {
    previewFile.value = filesForModal.value[0];
    return;
  }
  previewFile.value = filesForModal.value[currentPreviewFileIndex.value + 1];
};

const previewPrevFile = () => {
  if (currentPreviewFileIndex.value === 0) {
    previewFile.value = filesForModal.value[filesForModal.value.length - 1];
    return;
  }
  previewFile.value = filesForModal.value[currentPreviewFileIndex.value - 1];
};

/**Клик по компонену */
const onClick = () => {
  if (viewVariant.value !== FilePreviewVariantEnum.Inline) return;

  openFilePreviewModal();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'tir-pm-file-preview',
      {
        'is-small': viewVariant.value === _unref(FilePreviewVariantEnum).Small,
        'is-inline': viewVariant.value === _unref(FilePreviewVariantEnum).Inline,
        'is-loading': isLoading.value,
        'is-show-controls': isLoading.value || isOpenedConfirmDeletePopover.value,
        'is-proccessing': fileInfo.value.IsProccessing,
        'is-selected': __props.isSelected,
      },
    ]),
    onClick: onClick
  }, [
    (viewVariant.value !== _unref(FilePreviewVariantEnum).Inline)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", {
            class: "tir-pm-file-preview__wrapper-file",
            onClick: openFilePreviewModal
          }, [
            (fileType.value === _unref(FileTypeEnum).Image)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: fileInfo.value.Url,
                  draggable: false,
                  class: "tir-pm-file-preview__file tir-pm-file-preview__file--image"
                }, null, 8, _hoisted_1))
              : (fileType.value === _unref(FileTypeEnum).Other)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_unref(DocumentIcon)),
                    _createElementVNode("div", _hoisted_3, " ." + _toDisplayString(fileExtension.value), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    (fileInfo.value.VideoPreviewUrl)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "tir-pm-file-preview__video-preview-image",
                          src: fileInfo.value.VideoPreviewUrl
                        }, null, 8, _hoisted_5))
                      : _createCommentVNode("", true),
                    (!fileInfo.value.IsProccessing && !isLoading.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createVNode(_unref(PlayCircleIcon), { class: "tir-pm-file-preview__video-button-icon" })
                        ]))
                      : _createCommentVNode("", true)
                  ]))
          ]),
          (__props.variant !== _unref(FilePreviewVariantEnum).Small)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  (
              fileInfo.value.User &&
              fileInfo.value.Progress === undefined &&
              !fileInfo.value.IsProccessing
            )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createVNode(_unref(TirPmIconView), {
                          size: 24,
                          "color-code": fileInfo.value.User.AvatarColor,
                          "image-load-url": fileInfo.value.User.Image,
                          "is-rounded": "",
                          "is-bordered": false
                        }, {
                          mainSlot: _withCtx(() => [
                            _createTextVNode(_toDisplayString(computedFotoName.value), 1)
                          ]),
                          _: 1
                        }, 8, ["color-code", "image-load-url"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", {
                        class: _normalizeClass([
                  'tir-pm-file-preview__filename',
                  {
                    'full-width':
                      fileInfo.value.Progress !== undefined || fileInfo.value.IsProccessing,
                  },
                ])
                      }, _toDisplayString(fileName.value), 3),
                      _createElementVNode("div", _hoisted_12, " ." + _toDisplayString(fileExtension.value), 1)
                    ]),
                    (fileInfo.value.Progress === undefined && !fileInfo.value.IsProccessing)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createElementVNode("span", _hoisted_14, _toDisplayString(dateUploadString.value), 1),
                          (fileInfo.value.Size)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(sizeString.value), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (fileInfo.value.Progress !== undefined || fileInfo.value.IsProccessing)
                  ? (_openBlock(), _createBlock(_unref(FilePreviewProgress), {
                      key: 0,
                      class: "tir-pm-file-preview__progress",
                      variant: _unref(FilePreviewVariantEnum).Regular,
                      progress: fileInfo.value.Progress,
                      "is-proccessing": fileInfo.value.IsProccessing
                    }, null, 8, ["variant", "progress", "is-proccessing"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (
          __props.variant === _unref(FilePreviewVariantEnum).Small &&
          (fileInfo.value.Progress !== undefined || fileInfo.value.IsProccessing)
        )
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createVNode(_unref(FilePreviewProgress), {
                  variant: _unref(FilePreviewVariantEnum).Small,
                  progress: fileInfo.value.Progress,
                  "is-proccessing": fileInfo.value.IsProccessing
                }, null, 8, ["variant", "progress", "is-proccessing"])
              ]))
            : _createCommentVNode("", true),
          ((isViewControls.value || isAccessDownload.value) && !__props.hideControls)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                (isAccessDelete.value)
                  ? (_openBlock(), _createBlock(_unref(FilePreviewConfirmDeletePopover), {
                      key: 0,
                      ref_key: "$confirmDeletePopover",
                      ref: $confirmDeletePopover,
                      "is-opened": isOpenedConfirmDeletePopover.value,
                      "onUpdate:isOpened": _cache[0] || (_cache[0] = ($event: any) => ((isOpenedConfirmDeletePopover).value = $event)),
                      "is-loading": __props.isLoadingDelete,
                      onOnClickDelete: emitOnClickDelete
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(TirPmButton), {
                          size: _unref(TirPmButtonSizeEnum).Small,
                          variant: _unref(TirPmButtonVariantEnum).LinkState,
                          onClick: _withModifiers(onClickDelete, ["stop"])
                        }, {
                          leftSlot: _withCtx(() => [
                            _createVNode(_unref(CrossCompactIcon))
                          ]),
                          _: 1
                        }, 8, ["size", "variant", "onClick"])
                      ]),
                      _: 1
                    }, 8, ["is-opened", "is-loading"]))
                  : _createCommentVNode("", true),
                (isAccessEdit.value)
                  ? (_openBlock(), _createBlock(_unref(FilePreviewEditNamePopover), {
                      key: 1,
                      ref_key: "$editNamePopover",
                      ref: $editNamePopover,
                      "is-opened": isOpenedEditNamePopover.value,
                      "onUpdate:isOpened": _cache[1] || (_cache[1] = ($event: any) => ((isOpenedEditNamePopover).value = $event)),
                      "is-loading": __props.filesLoadingEditName.includes(fileInfo.value.FileId),
                      "file-name": fileInfo.value.Name,
                      onSaveFileName: _cache[2] || (_cache[2] = ($event: any) => (emit('saveName', fileInfo.value.FileId, $event)))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(TirPmButton), {
                          size: _unref(TirPmButtonSizeEnum).Small,
                          variant: _unref(TirPmButtonVariantEnum).LinkState,
                          onClick: _withModifiers(onClickEdit, ["stop"])
                        }, {
                          leftSlot: _withCtx(() => [
                            _createVNode(_unref(PencilSquareIcon))
                          ]),
                          _: 1
                        }, 8, ["size", "variant", "onClick"])
                      ]),
                      _: 1
                    }, 8, ["is-opened", "is-loading", "file-name"]))
                  : _createCommentVNode("", true),
                (isAccessDownload.value)
                  ? (_openBlock(), _createBlock(_unref(TirPmButton), {
                      key: 2,
                      size: _unref(TirPmButtonSizeEnum).Small,
                      variant: _unref(TirPmButtonVariantEnum).LinkState,
                      onClick: download
                    }, {
                      leftSlot: _withCtx(() => [
                        _createVNode(_unref(ArrowDownTrayIcon))
                      ]),
                      _: 1
                    }, 8, ["size", "variant"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (fileInfo.value.Progress !== undefined || fileInfo.value.IsProccessing)
            ? (_openBlock(), _createBlock(_unref(FilePreviewProgress), {
                key: 0,
                class: "tir-pm-file-preview__inline-progress",
                variant: _unref(FilePreviewVariantEnum).Inline,
                progress: fileInfo.value.Progress,
                "is-proccessing": fileInfo.value.IsProccessing
              }, null, 8, ["variant", "progress", "is-proccessing"]))
            : _createCommentVNode("", true),
          _createVNode(_unref(DocumentIcon), { class: "tir-pm-file-preview__inline-icon" }),
          _createElementVNode("span", _hoisted_18, _toDisplayString(fileName.value), 1),
          _createElementVNode("span", _hoisted_19, " ." + _toDisplayString(fileExtension.value), 1),
          (isViewControls.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                (isAccessDelete.value)
                  ? (_openBlock(), _createBlock(_unref(FilePreviewConfirmDeletePopover), {
                      key: 0,
                      ref_key: "$confirmDeletePopover",
                      ref: $confirmDeletePopover,
                      "is-opened": isOpenedConfirmDeletePopover.value,
                      "onUpdate:isOpened": _cache[3] || (_cache[3] = ($event: any) => ((isOpenedConfirmDeletePopover).value = $event)),
                      "is-loading": __props.isLoadingDelete,
                      onOnClickDelete: emitOnClickDelete
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          class: "tir-pm-file-preview__inline-button",
                          onClick: _withModifiers(onClickDelete, ["stop"])
                        }, [
                          _createVNode(_unref(CrossCompactIcon))
                        ], 8, _hoisted_21)
                      ]),
                      _: 1
                    }, 8, ["is-opened", "is-loading"]))
                  : _createCommentVNode("", true),
                (isAccessEdit.value)
                  ? (_openBlock(), _createBlock(_unref(FilePreviewEditNamePopover), {
                      key: 1,
                      ref_key: "$editNamePopover",
                      ref: $editNamePopover,
                      "is-opened": isOpenedEditNamePopover.value,
                      "onUpdate:isOpened": _cache[4] || (_cache[4] = ($event: any) => ((isOpenedEditNamePopover).value = $event)),
                      "is-loading": __props.filesLoadingEditName.includes(fileInfo.value.FileId),
                      "file-name": fileInfo.value.Name,
                      onSaveFileName: _cache[5] || (_cache[5] = ($event: any) => (emit('saveName', fileInfo.value.FileId, $event)))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          class: "tir-pm-file-preview__inline-button",
                          onClick: _withModifiers(onClickEdit, ["stop"])
                        }, [
                          _createVNode(_unref(PencilSquareIcon))
                        ], 8, _hoisted_22)
                      ]),
                      _: 1
                    }, 8, ["is-opened", "is-loading", "file-name"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ], 64)),
    (!__props.isDisabledOpen && fileInfo.value.Progress === undefined)
      ? (_openBlock(), _createBlock(_unref(FilePreviewModal), {
          key: 2,
          ref: "$filePreviewModal",
          file: (previewFile.value as any),
          "onUpdate:file": _cache[6] || (_cache[6] = ($event: any) => (((previewFile.value as any)) = $event)),
          "full-screen": previewFullscreenModal.value,
          "onUpdate:fullScreen": _cache[7] || (_cache[7] = ($event: any) => ((previewFullscreenModal).value = $event)),
          files: filesForModal.value,
          "is-view-next": filesForModal.value.length > 1,
          "is-view-prev": filesForModal.value.length > 1,
          "files-loading-edit-name": __props.filesLoadingEditName,
          onClose: closeFilePreviewModal,
          onOnClickDownload: download,
          onOnClickNext: previewNextFile,
          onOnClickPrev: previewPrevFile,
          onOnClickEdit: _cache[8] || (_cache[8] = ($event: any) => (emit('onClickEdit', $event))),
          onSaveName: emitSaveName
        }, null, 8, ["file", "full-screen", "files", "is-view-next", "is-view-prev", "files-loading-edit-name"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})